import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { EntityList, PageHead } from '../../components/EntityList';
import DebtEditor from './DebtEditor';
import { useLabels } from '../../hooks/useLabels';

function EditDebt() {
	const { t } = useLabels();
	const { id, accountId, contractId, assetSaleId } = useParams();
	const navigate = useNavigate();
	const { pathname } = useLocation();

	// Precise per-route prefixes (see App.js), matching NewDebt.jsx's
	// approach — contextual edits keep the tab's preload context so the
	// owner/contract/assetSale typeahead stays disabled and scoped.
	const preloadAccountId = pathname.startsWith('/AdminScreen/accounts/account/') ? accountId : null;
	const preloadContractId = pathname.startsWith('/AdminScreen/contracts/contract/') ? contractId : null;
	const preloadAssetSaleId = pathname.startsWith('/AdminScreen/assetSales/assetSale/') ? assetSaleId : null;

	const returnTo = preloadAccountId
		? `/AdminScreen/accounts/account/${preloadAccountId}`
		: preloadContractId
			? `/AdminScreen/contracts/contract/${preloadContractId}`
			: preloadAssetSaleId
				? `/AdminScreen/assetSales/assetSale/${preloadAssetSaleId}`
				: `/AdminScreen/debts/debt/${id}`;

	const breadcrumb = preloadAccountId
		? [
			{ label: 'Inicio', to: '/AdminScreen' },
			{ label: t('entity.account.plural'), to: '/AdminScreen/accounts' },
			{ label: 'Cuenta', to: `/AdminScreen/accounts/account/${preloadAccountId}` },
			{ label: `Editar ${t('entity.debt')}` },
		]
		: preloadContractId
			? [
				{ label: 'Inicio', to: '/AdminScreen' },
				{ label: t('entity.contract.plural'), to: '/AdminScreen/contracts' },
				{ label: 'Contrato', to: `/AdminScreen/contracts/contract/${preloadContractId}` },
				{ label: `Editar ${t('entity.debt')}` },
			]
			: preloadAssetSaleId
				? [
					{ label: 'Inicio', to: '/AdminScreen' },
					{ label: t('entity.assetSale.plural'), to: '/AdminScreen/assetSales' },
					{ label: 'Venta de activo', to: `/AdminScreen/assetSales/assetSale/${preloadAssetSaleId}` },
					{ label: `Editar ${t('entity.debt')}` },
				]
				: [
					{ label: 'Inicio', to: '/AdminScreen' },
					{ label: t('entity.debt.plural'), to: '/AdminScreen/debts' },
					{ label: `Editar ${t('entity.debt')}` },
				];

	return (
		<EntityList>
			<Helmet>
				<title>{`Editar ${t('entity.debt')}`}</title>
			</Helmet>
			<PageHead
				breadcrumb={breadcrumb}
				title={`Editar ${t('entity.debt')}`}
				subtitle={`Actualizá los datos de la ${t('entity.debt').toLowerCase()}.`}
			/>
			<DebtEditor
				mode='edit'
				debtId={id}
				onCancel={() => navigate(returnTo)}
				onSaved={() => navigate(returnTo)}
				saveLabel='Guardar'
				preloadAccountId={preloadAccountId}
				preloadContractId={preloadContractId}
				preloadAssetSaleId={preloadAssetSaleId}
			/>
		</EntityList>
	);
}

export default EditDebt;
